// §7.6 — the entirety of the newsletter's "backend": no fetch, no API
// route, no provider abstraction. Vite exposes env vars via
// import.meta.env (not process.env as in the spec's pseudocode, but same
// field names/shape — §5.6). EmailOctopus's hosted-form script embed is
// per-language again — separate DE/EN form IDs, each with its own list.
export const NEWSLETTER_FORM_ID = {
  de: import.meta.env.VITE_NEWSLETTER_FORM_ID_DE,
  en: import.meta.env.VITE_NEWSLETTER_FORM_ID_EN,
};
